/**
 * 物业菜单、物业路由
 */
export default {
  menuList: [ // todo 修改后，平台菜单需对应修改
    {
      title: '概况',
      key: 'dataView', // 自定义key
      icon: 'line-chart',
      subMenu: [
        { title: '数据概览', route: 'allVis', key: 'dataView' }// 每个页面组件name
      ]
    },
    {
      title: '小区管理',
      key: 'database',
      icon: 'database',
      subMenu: [
        { title: '小区管理', route: 'community', key: 'database' },
        { title: '楼栋管理', route: 'building', key: 'database' },
        { title: '单元管理', route: 'unit', key: 'database' },
        { title: '房间管理', route: 'room', key: 'database' },
        { title: '位置管理', route: 'location', key: 'database' }
      ]
    },
    {
      title: '住户管理',
      key: 'members',
      icon: 'user',
      subMenu: [
        { title: '住户信息', route: 'member', key: 'members' },
        { title: '住户认证', route: 'householdAuthRecord', key: 'members' },
        { title: '社区身份证', route: 'passport', key: 'members' },
        { title: '住户到期提醒', route: 'expired', key: 'members' }
      ]
    },
    {
      title: '管理中心',
      key: 'manageCenter',
      icon: 'team',
      subMenu: [
        { title: '角色管理', route: 'role', key: 'manageCenter' },
        { title: '用户管理', route: 'account', key: 'manageCenter' },
        { title: '操作日志', route: 'operationLog', key: 'manageCenter' }
      ]
    },
    {
      title: '消息中心',
      key: 'message',
      icon: 'dollar',
      subMenu: [
        { title: '社区公告', route: 'communityNotice', key: 'message' }
      ]
    },
    {
      title: '我的应用',
      key: 'device',
      icon: 'layout',
      subMenu: [
        { title: '智能门禁', route: 'entranceGuard', key: 'device' },
        { title: '报事报修', route: 'repair', key: 'device' },
        { title: '业委会管理', route: 'ownerCommittee', key: 'device' }
      ]
    }
  ],
  routes: [ // todo 修改后，平台路由需对应修改
    {
      path: '/allVis',
      name: 'allVis',
      menuKey: 'allVis',
      meta: {title: '浩邈智慧社区数据概览', breadNumber: 0}
    },
    {
      path: '/communityVis',
      name: 'communityVis',
      menuKey: 'allVis',
      meta: {title: '某社区数据概览', breadNumber: 0}
    },
    {
      path: '/expired',
      name: 'expired',
      menuKey: 'expired',
      btnList: [
        {title: '续期', key: 'delay'}
      ],
      meta: {title: '住户到期提醒', breadNumber: 0}
    },

    { // 业委会管理
      path: '/ownerCommittee',
      name: 'ownerCommittee',
      menuKey: 'ownerCommittee',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '成员管理', key: 'memberManage'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '业委会管理', breadNumber: 0}
    },
    {
      path: '/ownerCommittee/add',
      name: 'addOwnerCommittee',
      menuKey: 'ownerCommittee',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增业委会管理', breadNumber: 1}
    },
    {
      path: '/ownerCommittee/member',
      name: 'memberManage',
      menuKey: 'ownerCommittee',
      btnList: [
        {title: '添加成员', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '业委会成员管理', breadNumber: 1}
    },

    {
      path: '/room',
      name: 'room',
      menuKey: 'room', // menuKey: 二级菜单的name
      btnList: [
        {title: '添加房间', key: 'addbtn'},
        {title: '导入房间', key: 'import'},
        {title: '住户信息', key: 'holdInfo'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '房间管理', breadNumber: 0}
    },
    {
      path: '/room/info',
      name: 'roomInfo',
      menuKey: 'room',
      btnList: [
        {title: '删除', key: 'delete'},
        {title: '续期', key: 'delay'}
      ],
      meta: {title: '住户信息', breadNumber: 1}
    },
    {
      path: '/room/import',
      name: 'importRoom',
      menuKey: 'room',
      btnList: [
        {title: '下载模板', key: 'download'},
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '导入房间', breadNumber: 1}
    },
    {
      path: '/location',
      name: 'location',
      menuKey: 'location',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '位置管理', breadNumber: 0}
    },
    {
      path: '/location/add',
      name: 'addLocation',
      menuKey: 'location',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增位置', breadNumber: 1}
    },
    {
      path: '/unit',
      name: 'unit',
      menuKey: 'unit',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '单元管理', breadNumber: 0}
    },
    {
      path: '/addUnit',
      name: 'addUnit',
      menuKey: 'unit',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '添加单元', breadNumber: 1}
    },
    {
      path: '/community',
      name: 'community',
      menuKey: 'community',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '小区配置', key: 'config'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '小区管理', breadNumber: 0}
    },
    {
      path: '/community/add',
      name: 'addCommunity',
      menuKey: 'community',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增小区', breadNumber: 1}
    },
    {
      path: '/community/config',
      name: 'communityConfig',
      menuKey: 'community',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '小区配置', breadNumber: 1}
    },
    {
      path: '/building',
      name: 'building',
      menuKey: 'building',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '楼栋管理', breadNumber: 0}
    },
    {
      path: '/building/add',
      name: 'addBuilding',
      menuKey: 'building',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增楼栋', breadNumber: 1}
    },

    {
      path: '/member',
      name: 'member',
      menuKey: 'member',
      btnList: [
        {title: '详情', key: 'detail'},
        {title: '住房信息', key: 'houseInfo'}
      ],
      meta: {title: '住户信息', breadNumber: 0}
    },
    {
      path: '/member/detail',
      name: 'memberDetail',
      menuKey: 'member',
      meta: {title: '住户详情', breadNumber: 1}
    },
    {
      path: '/member/housingInfo',
      name: 'housingInfo',
      menuKey: 'member',
      btnList: [
        {title: '添加房间', key: 'addbtn'},
        {title: '删除', key: 'delete'},
        {title: '续期', key: 'delay'}
      ],
      meta: {title: '住房信息', breadNumber: 1}
    },
    {
      path: '/householdAuthRecord',
      name: 'householdAuthRecord',
      menuKey: 'householdAuthRecord',
      btnList: [
        {title: '审核', key: 'audit'},
        {title: '详情', key: 'detail'}
      ],
      meta: {title: '住户认证记录', breadNumber: 0}
    },
    {
      path: '/householdAuthRecord/detail',
      name: 'householdAuthDetail',
      menuKey: 'householdAuthRecord',
      btnList: [
        {title: '通过', key: 'pass'},
        {title: '拒绝', key: 'reject'}
      ],
      meta: {title: '住户认证详情', breadNumber: 1}
    },
    {
      path: '/passport',
      name: 'passport',
      menuKey: 'passport',
      btnList: [
        {title: '状态切换', key: 'status'}
      ],
      meta: {title: '社区身份证', breadNumber: 0}
    },
    {
      path: '/communityNotice',
      name: 'communityNotice',
      menuKey: 'communityNotice',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'},
        {title: '展示首页状态切换', key: 'status'}
      ],
      meta: {title: '社区公告', breadNumber: 0}
    },
    {
      path: '/communityNotice/add',
      name: 'addNotice',
      menuKey: 'communityNotice',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增社区公告', breadNumber: 1}
    },

    // 门禁
    {
      path: '/entranceGuard',
      redirect: '/entranceGuard/smartDoor',
      name: 'entranceGuard',
      menuKey: 'entranceGuard',
      meta: {title: '门禁应用父级', breadNumber: 0},
      children: [
        {
          path: 'smartDoor',
          name: 'smartDoor',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '详情', key: 'detail'},
            {title: '重启', key: 'restart'}
          ],
          meta: {title: '门禁设备', breadNumber: 0}
        },
        {
          path: 'smartDoor/detail',
          name: 'smartDoorDetail',
          menuKey: 'entranceGuard',
          meta: {title: '门禁设备详情', breadNumber: 1}
        },
        {
          path: 'keyApply',
          name: 'keyApply',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '审核', key: 'audit'},
            {title: '详情', key: 'detail'}
          ],
          meta: {title: '钥匙申请', breadNumber: 0}
        },
        {
          path: 'keyApply/detail',
          name: 'keyApplyDetail',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '通过', key: 'pass'},
            {title: '拒绝', key: 'reject'}
          ],
          meta: {title: '钥匙申请详情', breadNumber: 1}
        },
        {
          path: 'householdKey',
          name: 'householdKey',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '分配钥匙', key: 'allocKey'},
            {title: '批量删除', key: 'batchDel'},
            {title: '删除', key: 'delete'}
          ],
          meta: {title: '住户钥匙列表', breadNumber: 0}
        },
        {
          path: 'householdKey/alloc',
          name: 'householdAlloc',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '下一步', key: 'next'},
            {title: '提交', key: 'submit'}
          ],
          meta: {title: '分配住户钥匙', breadNumber: 1}
        },
        {
          path: 'stewardKey',
          name: 'stewardKey',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '分配钥匙', key: 'allocKey'},
            {title: '批量删除', key: 'batchDel'},
            {title: '删除', key: 'delete'}
          ],
          meta: {title: '管家通行', breadNumber: 0}
        },
        {
          path: 'stewardKey/alloc',
          name: 'stewardAlloc',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '下一步', key: 'next'},
            {title: '提交', key: 'submit'}
          ],
          meta: {title: '分配管家钥匙', breadNumber: 1}
        },
        {
          path: 'cardRecord',
          name: 'cardRecord',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '状态切换', key: 'status'},
            {title: '删除', key: 'delete'}
          ],
          meta: {title: '制卡记录', breadNumber: 0}
        },
        {
          path: 'openLog',
          name: 'openLog',
          menuKey: 'entranceGuard',
          btnList: [
            {title: '查看抓拍', key: 'show'}
          ],
          meta: {title: '开门日志', breadNumber: 0}
        }
      ]
    },

    {
      path: '/repair',
      name: 'repair',
      menuKey: 'repair',
      btnList: [
        {title: '回复', key: 'answer'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '报事报修', breadNumber: 0}
    },
    {
      path: '/role',
      name: 'role',
      menuKey: 'role',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: 'API权限', key: 'apiAuth'},
        {title: 'API权限', key: 'viewAuth'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '角色管理', breadNumber: 0}
    },
    {
      path: '/role/add',
      name: 'addRole',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增角色', breadNumber: 1}
    },
    {
      path: '/role/api',
      name: 'manageApiAuth',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置API权限', breadNumber: 1}
    },
    {
      path: '/role/view',
      name: 'manageViewAuth',
      menuKey: 'role',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '配置视图权限', breadNumber: 1}
    },
    {
      path: '/account',
      name: 'account',
      menuKey: 'account',
      btnList: [
        {title: '新增', key: 'addbtn'},
        {title: '批量删除', key: 'batchDel'},
        {title: '状态切换', key: 'status'},
        {title: '分管小区', key: 'alloc'},
        {title: '重置密码', key: 'resetPwd'},
        {title: '修改', key: 'edit'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '用户管理', breadNumber: 0}
    },
    {
      path: '/account/add',
      name: 'addAccount',
      menuKey: 'account',
      btnList: [
        {title: '提交', key: 'submit'}
      ],
      meta: {title: '新增用户', breadNumber: 1}
    },
    {
      path: '/account/allocCommunity',
      name: 'allocCommunity',
      menuKey: 'account',
      btnList: [
        {title: '添加分管小区', key: 'addbtn'},
        {title: '状态切换', key: 'status'},
        {title: '管家app功能配置', key: 'config'},
        {title: '删除', key: 'delete'}
      ],
      meta: {title: '分管小区', breadNumber: 1}
    },
    {
      path: '/operationLog',
      name: 'operationLog',
      menuKey: 'operationLog',
      btnList: [
        {title: '账号详情', key: 'detail'}
      ],
      meta: {title: '管理员操作日志', breadNumber: 0}
    },
    {
      path: '*',
      name: 'noPage'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/propertyMenuRoutes.js